import { WizardEmissao } from './emitir/WizardEmissao';
import type { CooperadoAba } from '../types';

interface Props {
  /** Propagado até a tela de bloqueio, que precisa levar às faturas. */
  onNavegar?: (aba: CooperadoAba) => void;
}

/** O wizard ocupa a área inteira, sem o padding das outras abas (handoff §0). */
export function EmitirAba({ onNavegar }: Props) {
  return <WizardEmissao onNavegar={onNavegar} />;
}
